import {
  LabelInput,
  EntryTypeSelect,
  DefaultValueInput,
  RequiredToggle,
  ReadOnlyToggle,
  StandardDesignConfig,
  HideOnFormToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel' 

export const RatingStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  DefaultValueInput,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnFormToggle,
]
